const mapDeep = require('deepdash/mapDeep');
const isString = require('lodash/isString');
const Ajv = require('ajv');
const cloneDeep = require('lodash/cloneDeep');

const replaceReferences = schemas =>
  mapDeep(schemas, (value, key) => (key === '$ref' && isString(value) ? value.replace(/^.+#/, '#') : value));

const createInlineSchema = (...schemas) =>
  schemas.reduce(
    (acc, cur) => ({ ...acc, ...cur, definitions: { ...acc.definitions, ...replaceReferences(cur.definitions) } }),
    { definitions: {} }
  );

const resolveSchema = (...sources) => createInlineSchema(require('../schema.json'), ...sources);

const filterPayload = (schema, values) => {
  const ajv = new Ajv({ removeAdditional: true, useDefaults: true });
  const data = cloneDeep(values);
  const validate = ajv.compile(schema);
  validate(data);
  return data;
};

module.exports = { createInlineSchema, replaceReferences, resolveSchema, filterPayload };
